export default __webpack_public_path__ + "static/media/NH21_721_ELLE_PABLO1523.306782eb.jpg";